<template>
  <section class="TcHome container px-5 flex-1 mx-auto flex items-center gap-5 h-full">
    <button @click="$root.setPage('new-appointment')"
      class="flex-1 btn btn-jumbo">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>Cita previa</span>
    </button>
    <button @click="$root.setPage('events-list')"
      class="flex-1 btn btn-jumbo">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
      <span class="text-left">Inscripción Eventos / Actividades</span>
    </button>
  </section>
</template>

<script>
export default {
  name: 'TcHome',
  data () {
    return {}
  }
}
</script>